enum ZlucitelnostSPravomEuEnum {
  UPLNE = 'UPLNE',
  CIASTOCNE = 'CIASTOCNE',
  NIE_JE = 'NIE_JE',
}

function zlucitelnostEnumFromNazov(nazov: string): ZlucitelnostSPravomEuEnum {
  switch (nazov) {
    case 'úplne':
      return ZlucitelnostSPravomEuEnum.UPLNE;
    case 'čiastočne':
      return ZlucitelnostSPravomEuEnum.CIASTOCNE;
    case 'nie je':
      return ZlucitelnostSPravomEuEnum.NIE_JE;
    default:
      return ZlucitelnostSPravomEuEnum.CIASTOCNE;
  }
}

export {
  ZlucitelnostSPravomEuEnum, zlucitelnostEnumFromNazov,
};
